module.exports = __webpack_public_path__ + "img/7.1196b17b.jpg";